/**
 * @file 常用工具函数
 * @author 李小龙
 * @date 2018/5/31
 */

// 防止函数连续触发
export function debounce(name, callback, delay, ...args) {
  var interval = Date.now() - Number(sessionStorage['debounce_' + name] || 0)
  if (interval >= delay) {
    sessionStorage['debounce_' + name] = Date.now()
    callback(...args)
  }
}

// 将树前序遍历展开成数组
export function flatten(root, key) {
  var result = [key == null ? root : root[key]]
  if (root.children)
    root.children.forEach(c => {
      result = result.concat(flatten(c, key))
    })
  return result
}
// 将树数组前序遍历展开成数组
export function flattenArray(rootArr, key) {
  return rootArr.reduce((pre, cur) => {
    return pre.concat(flatten(cur))
  }, [])
}

//在对象指定处插入键值并返回为新对象
export function objectInsert(obj, place, key, val) {
  var result = {}, index = 0
  for (var i in obj) {
    if (index == place) result[key] = val
    result[i] = obj[i]
    index++
  }
  return result
}

//时间日期相关
export function formatDate(d, format) {
  var o = {
    'M+': d.getMonth() + 1, // month
    'd+': d.getDate(), // day
    'h+': d.getHours(), // hour
    'H+': d.getHours(), // hour
    'm+': d.getMinutes(), // minute
    's+': d.getSeconds(), // second
  }
  //将连续的y转换成年的最后几位
  if (/(y+)/.test(format)) {
    format = format.replace(
      RegExp.$1,
      (d.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }
  //连续两个前面以0补全，只有一个不补
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
    }
  }
  return format
}

//个人信息部分隐藏
export function plusXing (str, frontLen, endLen) { //str：字符串，frontLen：前面保留位数，endLen：后面保留位数
  var len = str.length-frontLen-endLen
  var xing = ''
  for (var i=0; i<len; i++) {
    xing += '*'
  }
  return str.substring(0, frontLen) + xing + str.substring(str.length-endLen)
}

export function formatToDate(d) {
  return formatDate(d, 'yyyy-MM-dd')
}

export function formatToDateTime(d) {
  return formatDate(d, 'yyyy-MM-dd hh:mm:ss')
}

export function rangeValidator(f) {
  if (f.begDate && f.endDate && new Date(f.begDate) > new Date(f.endDate)) {
    vm.$message.error('开始日期不得大于结束日期')
    return false
  }
  return true
}



// WEBPACK FOOTER //
// ./src/js/util.js